import {Provider} from '@angular/core';
import {TestResultService} from './shared/services/api-services/test-result.service';
import {SettingService} from './shared/services/setting.service';
import {ApiService} from './shared/services/api.service';
import {AuthenticationService} from './shared/services/authentication.service';
import {LoginSessionStorageService, LoginStorageService} from './shared/services/login-storage.service';
import {SvgPathService} from './shared/directives/svg/svg-path.service';
import {ErrorDictionaryService} from './shared/services/utilities/error-dictionary.service';
import {NotificationService} from './shared/services/utilities/notification.service';
import {NationalCodeValidatorService} from './shared/services/utilities/national-code-validator.service';
import {RadiographyService} from './shared/services/api-services/radiography.service';

export const PRODUCTION_PROVIDERS: Provider[] = [
  TestResultService,
  SettingService,
  RadiographyService,
  ApiService,
  AuthenticationService,
  SvgPathService,
  ErrorDictionaryService,
  NotificationService,
  NationalCodeValidatorService,
  {provide: LoginStorageService, useClass: LoginSessionStorageService}
];
